import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'notices',
    'uploadNotice',
    'deleteNotice',
    'image',
    'fileField',
    'deleteCheckBox',
  ];

  onImageClick() {
    this.fileFieldTarget.click();
  }

  onImageChosen(event) {
    const url = URL.createObjectURL(event.currentTarget.files[0]);
    this.imageTarget.setAttribute('src', url);
    this.noticesTarget.hidden = false;
    this.imageTarget.hidden = false;
    this.uploadNoticeTarget.hidden = false;
    this.deleteCheckBoxTarget.checked = false;
    this.deleteNoticeTarget.hidden = true;
  }

  onImageDelete(event) {
    if (event.target.checked) {
      this.noticesTarget.hidden = false;
      this.deleteNoticeTarget.hidden = false;
      this.imageTarget.hidden = true;
      this.uploadNoticeTarget.hidden = true;
    } else {
      this.deleteNoticeTarget.hidden = true;
      this.imageTarget.hidden = false;
    }
  }
}
